import {Player} from '@lottiefiles/react-lottie-player';
import React from 'react';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

const LOTTIE_LOGO =
  '/assets/content-lab/lotties/ltx-scaler-logo-animated-1.json';
const LOGO_SIZE = 120;

export type LtxScalerLoaderProps = {
  testID?: string;
  light?: boolean;
  absolute?: boolean;
  className?: string;
};

const Container = styled(Box)<{light?: boolean; absolute?: boolean}>(
  ({light, absolute}) => ({
    position: light || absolute ? 'absolute' : 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    background: light ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0.9)',
    zIndex: 10,
  })
);

function LtxScalerLoader(props: LtxScalerLoaderProps) {
  const {testID = 'ltx-scaler-loader', light, absolute, className = ''} = props;

  return (
    <Container
      light={light}
      absolute={absolute}
      className={className}
      data-testid={testID}
    >
      <Player
        src={LOTTIE_LOGO}
        autoplay
        loop
        style={{width: LOGO_SIZE, height: LOGO_SIZE}}
      />
    </Container>
  );
}

export default LtxScalerLoader;
